import { useEffect, useState, useCallback } from 'react';
import { apiurl } from '../utils/constants';

function DOC({ doc, comp }) {

	import('../styles/dark.css');
	import('../styles/sap.css');

	const [order, setOrder] = useState([]);
	const [loading, setLoading] = useState(true);

	//let DB = 'ormdb';
	let sapDB = 'CLTSTTHORINGENIERIA';

	switch (comp) {
		case "1":
			//DB = 'ormdb__tian';
			sapDB = 'CLPRDTHORINGENIERIA';
			break;
		case "2":
			//DB = 'ormdb__tsaan';
			sapDB = 'CLPRDTHORSERVYASESORIAS';
			break;
		case "3":
			//DB = 'ormdb__tlog';
			sapDB = 'CLPRDTHORTRANSPYLOGISTICA';
			break;
		default:
			break;
	}

	const loaddivOrders = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'orderByDocNum', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({ sapDB, DocNum: doc })
			});

			if (response.ok) {
				const div = await response.json();
				if (div) {
					setOrder(div[0]);
				} else {
					console.error('No se encontraron órdenes de compra');
				}
			} else {
				console.error('Error al cargar las órdenes de compra');
			}

		} catch (error) {
			console.error('Error al cargar las órdenes de compra:', error);
			return null;
		} finally {
			setLoading(false);
		}
	}, [sapDB, doc]);

	useEffect(() => {
		loaddivOrders();
	}, [loaddivOrders])

	const evalStatusOrder = (status) => {
		switch (status) {
			case 'N':
				return 'No aprobado';
			case 'Y':
				return 'Aprobado';
			case 'W':
				return 'Rechazado';
			default:
				return 'Desconocida';
		}
	}

	return (
		loading ? <h1 style={{ textAlign: 'center' }}>Cargando datos...</h1> :
			<>
				<main>

					<section>
						<header>
							<figure></figure>

							<aside>
								<h1>THOR INGENIERIA EN AHORRO DE NEUMÁTICOS</h1>
								<div>RUT / TaxID: 76184440-7</div>
								<div>Giro: SERVICIOS A LA MINERIA</div>
								<div className="p">
									<div>Teléfono / Phone: 572 518301</div>
									<div>Sitio Web / Website: bailac.com</div>
									<div>Dirección de despacho / Shipping Address: SERRANO ; IQUIQUE ;CL</div>
									<div>Dirección de facturación / Billing Address: SERRANO ; IQUIQUE ;CL</div>
								</div>
							</aside>
							<aside>
								<hgroup>
									<div>
										<div>Orden de compra:</div>
										<div>Purchase order</div>
									</div>
									<h1>{order.DocNum}</h1>
								</hgroup>
								<div className="p">
									<div>Fecha Doc / Doc Date: {order.DocDate
										? new Date(order.DocDate).toLocaleDateString('es-ES', {
											day: '2-digit',
											month: 'short',
											year: 'numeric'
										}).replace(/ /g, '-')
										: ''}
									</div>
									<div>Estado: {evalStatusOrder(order.Status)}</div>
									<div>Autorizado por: {order.U_NAME}</div>
									<div>Centro de costo: {order.nameOcr}</div>
								</div>
							</aside>
						</header>
					</section>

					<section>
						<header>
							<article>
								<div>Proveedor / Supplier: {order.CardCode}</div>
								<div>Nombre / Name: {order.CardName}</div>
								<div>Dirección / Address: {order.Address}</div>
								<div>Teléfono / Phone: {order.Phone1 ?? ''}</div>
								<div>Persona de Contacto / Contact Person: {order.CntctPrsn ?? ''}</div>
								<div>Condición de Pago / Payments Terms: {order.PymntGroup}</div>
							</article>
							<article>
								<div>Moneda / Currency: {order.DocCur}</div>
								<hgroup>
									<div>Tipo de Cambios / Exchange Rate:</div>
									<table><tbody>
										<tr><td class="number">USD</td><td class="number">{order.USD_Rate}</td></tr>
										<tr><td class="number">EUR</td><td class="number">{order.EUR_Rate}</td></tr>
										<tr><td class="number">UF</td><td class="number">{order.UF_Rate}</td></tr>
									</tbody></table>
								</hgroup>
							</article>
						</header>
					</section>

					<section>
						<table>
							<thead>
								<td>N°</td>
								<td>Código / Code</td>
								<td>Descripción / Description</td>
								<td>Cant. / Qty</td>
								<td>UM</td>
								<td>Precio U. / U. Price</td>
								<td>Desc / Disc</td>
								<td>Total</td>
							</thead>
							<tbody>
								{
									order.items && order.items.map((items, index) => (
										<tr key={index}>
											<td>{index + 1}</td>
											<td>{items.ItemCode}</td>
											<td>
												<div>{items.Dscription}</div>
												<p>{items.FreeTxt}</p>
											</td>
											<td class="number">{items.Quantity}</td>
											<td>{items.UomCode}</td>
											<td class="number">{order.DocCur} {(items.Price ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
											<td class="number">{items.DiscPrcnt ?? 0}%</td>
											<td class="number">{order.DocCur} {(items.Quantity * items.Price * (1 - (items.DiscPrcnt ?? 0) / 100)).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
										</tr>
									))
								}

							</tbody>
						</table>
					</section>

					<footer>
						<article>
							<b>Emitida por / Created by: {order.CreatedByName}</b>
							<div className="p">
								<b>Notas/Notes:</b> {order.Comments ?? ''}
							</div>
						</article>
						<section style={{ width: '400px' }}>
							<header>
								<table>
									<tbody>
										<tr>
											<td>Neto:</td>
											<td>{order.DocCur}</td>
											<td className="number">{((order.DocTotal ?? 0) - (order.VatSum ?? 0)).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
										</tr>
										<tr>
											<td>IVA 19%:</td>
											<td>{order.DocCur}</td>
											<td className="number">{(order.VatSum ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
										</tr>
										<tr>
											<td>Gastos:</td>
											<td>{order.DocCur}</td>
											<td className="number">{(order.TotalExpns ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
										</tr>
										<tr>
											<td>Total:</td>
											<td>{order.DocCur}</td>
											<td className="number">{(order.DocTotal ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
										</tr>
									</tbody>
								</table>
							</header>
						</section>
					</footer>

					<footer>
						<b>Page 1 of 1</b>
						<h2>THOR INGENIERIA EN AHORRO DE NEUMATICOS</h2>
						<aside className="number">
							{/* eslint-disable-next-line jsx-a11y/alt-text */}
							<img src="https://ems.bailac.net/images/sap.png" />
						</aside>
					</footer>

				</main>
			</>
	)

}


export default DOC;
